export function formatPrice(price) {
  return price > 0 ? (price / 100).toFixed(2) : null;
}
